module.exports = __webpack_public_path__ + "img/Butterfly_00216.03f829e3.png";